import React from 'react';
import { Omit } from '@futrli/shared-services';

import { Cell, CellProps } from '../cell';
import { CurrentPeriod, CurrentPeriodProps } from './current-period';
import { NOT_ALLOWED_NUMBER_EXPLAINED } from '../number-explained/number-explained-messages';

type Props = Omit<CurrentPeriodProps, 'cellComponent' | 'predictedValue'> & CellProps;

export const CurrentPeriodCell: React.FC<Props> = ({
  value,
  index,
  canonicalCategory,
  hideDifference,
  hidePeriodToDate,
  periodToDateValue,
  maxDigits,
  rowHeight,
  showDecimals,
  rowHeightOverride,
  isAssumption,
  isDisabled,
  isExpanded,
  isFirst,
  isLast,
  isLevel1,
  isPercentage,
  isChild,
  isBold,
  strikeThrough,
  forceRowSize,
  numberExplained,
  joinedCell,
  periodType,
  category,
  hideCellContent
}) => {
  return (
    <CurrentPeriod
      index={index}
      canonicalCategory={canonicalCategory}
      hideDifference={hideDifference}
      hidePeriodToDate={hidePeriodToDate}
      predictedValue={value}
      isAssumption={isAssumption}
      isDisabled={isDisabled}
      isExpanded={isExpanded}
      isFirst={isFirst}
      isLast={isLast}
      isLevel1={isLevel1}
      isPercentage={isPercentage}
      isChild={isChild}
      isBold={isBold}
      periodToDateValue={periodToDateValue}
      maxDigits={maxDigits}
      rowHeight={rowHeight}
      rowHeightOverride={rowHeightOverride}
      showDecimals={showDecimals}
      forceRowSize={forceRowSize}
      numberExplained={numberExplained}
      joinedCell={joinedCell}
      periodType={periodType}
      category={category}
      cellComponent={
        <Cell
          value={value}
          index={index}
          maxDigits={maxDigits}
          rowHeight={rowHeight}
          showDecimals={showDecimals}
          rowHeightOverride={rowHeightOverride}
          isChild={isChild}
          isBold={isBold}
          isPercentage={isPercentage}
          isDisabled={isDisabled}
          isCurrentPeriod={true}
          strikeThrough={strikeThrough}
          forceRowSize={forceRowSize}
          numberExplained={NOT_ALLOWED_NUMBER_EXPLAINED}
          periodType={periodType}
          hideCellContent={hideCellContent}
          isAssumption={isAssumption}
        />
      }
    />
  );
};
